import { useI18n } from 'hooks/useI18n';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const AverageSalaryByTechnology: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const data = [
    {
      years: '',
      CSS: 23.16857142857143,
      React: 23.603448275862068,
      MySQL: 23.628205128205128,
      HTML: 23.279141104294478,
      Git: 23.796875,
      Docker: 26.394736842105264,
      SQL: 26.036585365853657,
      NodeJS: 23.113095238095237,
      MongoDB: 23.50943396226415,
      AWS: 28.444444444444446
    },
    {
      years: '<2y',
      CSS: 25.377840909090907,
      React: 26.059151785714285,
      MySQL: 25.84697508896797,
      HTML: 25.37953091684435,
      Git: 27.088709677419356,
      Docker: 28.316037735849054,
      SQL: 26.77777777777778,
      NodeJS: 26.03146853146853,
      MongoDB: 26.893617021276597,
      AWS: 31.41176470588235
    },
    {
      years: '2-5y',
      CSS: 35.61049107142857,
      React: 38.77317073170732,
      MySQL: 38.018840579710144,
      HTML: 35.39650537634409,
      Git: 38.99515738498789,
      Docker: 42.1554054054054,
      SQL: 39.566343042071196,
      NodeJS: 39.33859649122807,
      MongoDB: 39.98031496062992,
      AWS: 44.98774509803922
    },
    {
      years: '5-10y',
      CSS: 46.70847457627119,
      React: 51.39966555183946,
      MySQL: 47.98691860465116,
      HTML: 46.1875,
      Git: 50.155325443786985,
      Docker: 52.42524916943521,
      SQL: 50.3195020746888,
      NodeJS: 52.16822429906542,
      MongoDB: 51.807870370370374,
      AWS: 56.35040983606558
    },
    {
      years: '>10y',
      CSS: 50.37602179836512,
      React: 58.94366197183099,
      MySQL: 54.005692599620495,
      HTML: 50.6,
      Git: 54.91219512195122,
      Docker: 60.262472885032544,
      SQL: 56.474393530997304,
      NodeJS: 57.336776859504134,
      MongoDB: 58.427304964539005,
      AWS: 62.56390977443609
    }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400}>
          <LineChart data={data} margin={{ left: 10, bottom: 20 }}>
            <CartesianGrid strokeDasharray="1 1 " />
            <XAxis
              dataKey="years"
              tickLine={false}
              tickMargin={8}
              label={{
                value: t('salaries.average-by-language.years-label'),
                position: 'insideBottom',
                offset: -13,
                style: { transformOrigin: 'center center' }
              }}
            />
            <YAxis
              tickLine={false}
              tickMargin={10}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              label={{
                value: t('salaries.average-by-language.salary-label'),
                position: 'insideLeft',
                offset: -8,
                angle: -90
              }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{
                borderBottom: '1px solid #4d485c',
                marginBottom: '6px',
                fontWeight: 900
              }}
              separator=": "
              formatter={(value: number) => '€' + value.toFixed(1) + 'K'}
              labelFormatter={(label: string) =>
                label + ' ' + t('salaries.average-by-language.tooltip-years')
              }
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="top"
              iconType="square"
              width={120}
            />
            <Line dataKey="CSS" dot={false} strokeWidth={2} stroke="#E7278A" />
            <Line
              dataKey="React"
              dot={false}
              strokeWidth={2}
              stroke="#666666"
            />
            <Line
              dataKey="MySQL"
              dot={false}
              strokeWidth={2}
              stroke="#E3A702"
            />
            <Line dataKey="HTML" dot={false} strokeWidth={2} stroke="#E41B1E" />

            <Line dataKey="Git" dot={false} strokeWidth={2} stroke="#65A41E" />
            <Line
              dataKey="Docker"
              dot={false}
              strokeWidth={2}
              stroke="#A6761D"
            />
            <Line dataKey="SQL" dot={false} strokeWidth={2} stroke="#D95F02" />
            <Line
              dataKey="NodeJS"
              dot={false}
              strokeWidth={2}
              stroke="#1B9D76"
            />
            <Line
              dataKey="MongoDB"
              dot={false}
              strokeWidth={2}
              stroke="#746FB3"
            />
            <Line dataKey="AWS" dot={false} strokeWidth={2} stroke="#1E77B3" />
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default AverageSalaryByTechnology;
